import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
}
const DeleteDialog: React.FC<DeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
}) => {
  const { t } = useTranslation('chat');
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          padding: '8px',
        },
      }}
    >
      <DialogTitle sx={{
        color: '#2D3748',
        fontWeight: 600,
        fontSize: '1.1rem',
        pb: 1,
      }}>
        {title || t('deleteDialog.title')}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: '#4A5568' }}>
          {message || t('deleteDialog.message')}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          sx={{
            color: '#4A5568',
            '&:hover': {
              bgcolor: '#F7FAFC',
            },
          }}
        >
          {t('deleteDialog.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            bgcolor: '#E53E3E',
            color: 'white',
            '&:hover': {
              bgcolor: '#C53030',
            },
          }}
        >
          {t('deleteDialog.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DeleteDialog;
